/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ui_Te_UnavailableInputs */

const en_ui_te_unavailable = /** @type {(inputs: Ui_Te_UnavailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Training effect unavailable`)
};

const de_ui_te_unavailable = /** @type {(inputs: Ui_Te_UnavailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trainingseffekt nicht verfügbar`)
};

/**
* | output |
* | --- |
* | "Training effect unavailable" |
*
* @param {Ui_Te_UnavailableInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const ui_te_unavailable = /** @type {((inputs?: Ui_Te_UnavailableInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ui_Te_UnavailableInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ui_te_unavailable(inputs)
	return de_ui_te_unavailable(inputs)
});